var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaDwgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.972,
    height: 90.05,
    viewBox: "0 0 78.972 90.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minerva_dwg_icon",
    transform: "translate(-1234 -8755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minerva_dwg_icon-2",
    "data-name": "minerva_dwg_icon",
    transform: "translate(1234 8755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186433",
    "data-name": "\\uADF8\\uB8F9 186433",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186431",
    "data-name": "\\uADF8\\uB8F9 186431",
    transform: "translate(7.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186422",
    "data-name": "\\uADF8\\uB8F9 186422",
    transform: "translate(4.233 4.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186421",
    "data-name": "\\uADF8\\uB8F9 186421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139267",
    "data-name": "\\uD328\\uC2A4 139267",
    d: "M128.808,122.743H65.7a1.821,1.821,0,0,1-1.821-1.821V38.747A1.821,1.821,0,0,1,65.7,36.926h63.107a1.821,1.821,0,0,1,1.821,1.821v82.174A1.821,1.821,0,0,1,128.808,122.743Z",
    transform: "translate(-63.879 -36.926)",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186430",
    "data-name": "\\uADF8\\uB8F9 186430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186428",
    "data-name": "\\uADF8\\uB8F9 186428",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186423",
    "data-name": "\\uADF8\\uB8F9 186423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139268",
    "data-name": "\\uD328\\uC2A4 139268",
    d: "M97.97,27.631H56.4a1.821,1.821,0,0,0-1.821,1.821v82.174a1.821,1.821,0,0,0,1.821,1.821h63.107a1.821,1.821,0,0,0,1.821-1.821V50.239Z",
    transform: "translate(-54.583 -27.631)",
    fill: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186425",
    "data-name": "\\uADF8\\uB8F9 186425",
    transform: "translate(1.82 1.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186424",
    "data-name": "\\uADF8\\uB8F9 186424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139269",
    "data-name": "\\uD328\\uC2A4 139269",
    d: "M59.491,107.458a.913.913,0,0,1-.911-.911V32.541a.922.922,0,0,1,.269-.642.9.9,0,0,1,.642-.269H85.663a.911.911,0,1,1,0,1.821H60.4v73.1A.911.911,0,0,1,59.491,107.458ZM89.306,33.451a.911.911,0,1,1,.911-.911A.911.911,0,0,1,89.306,33.451Z",
    transform: "translate(-58.58 -31.63)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186426",
    "data-name": "\\uADF8\\uB8F9 186426",
    transform: "translate(0 18.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139270",
    "data-name": "\\uD328\\uC2A4 139270",
    d: "M116.78,67.605v61.24a1.821,1.821,0,0,1-1.821,1.821H54.583V133.4A1.821,1.821,0,0,0,56.4,135.22h63.107a1.821,1.821,0,0,0,1.821-1.821V72.011Z",
    transform: "translate(-54.583 -67.605)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186427",
    "data-name": "\\uADF8\\uB8F9 186427",
    transform: "translate(0 20.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139271",
    "data-name": "\\uD328\\uC2A4 139271",
    d: "M119.057,72.444v61.314a1.821,1.821,0,0,1-1.821,1.821H54.583v.455a1.821,1.821,0,0,0,1.821,1.821h63.107a1.821,1.821,0,0,0,1.821-1.821V74.647Z",
    transform: "translate(-54.583 -72.444)",
    fill: "#d1d3d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186429",
    "data-name": "\\uADF8\\uB8F9 186429",
    transform: "translate(43.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139272",
    "data-name": "\\uD328\\uC2A4 139272",
    d: "M149.867,48.532a1.707,1.707,0,0,0,1.707,1.707H173.23L149.867,27.631Z",
    transform: "translate(-149.867 -27.631)",
    fill: "#d1d3d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186432",
    "data-name": "\\uADF8\\uB8F9 186432",
    transform: "translate(0 6.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139273",
    "data-name": "\\uD328\\uC2A4 139273",
    d: "M80.05,57.833H38.859a1.821,1.821,0,0,1-1.821-1.821V43.4a1.821,1.821,0,0,1,1.821-1.821H80.05A1.821,1.821,0,0,1,81.871,43.4V56.012A1.821,1.821,0,0,1,80.05,57.833Z",
    transform: "translate(-37.038 -41.574)",
    fill: "#2266d3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186649",
    "data-name": "\\uADF8\\uB8F9 186649",
    transform: "translate(1249.556 8781.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154680",
    "data-name": "\\uC0AC\\uAC01\\uD615 154680",
    d: "M.643-3H8.383A3.647,3.647,0,0,1,12.026.643V8.383a3.647,3.647,0,0,1-3.643,3.643H.643A3.647,3.647,0,0,1-3,8.383V.643A3.647,3.647,0,0,1,.643-3ZM8.383,9.294a.912.912,0,0,0,.911-.911V.643a.912.912,0,0,0-.911-.911H.643A.912.912,0,0,0-.268.643V8.383a.912.912,0,0,0,.911.911Z",
    transform: "translate(12.488 21.774)",
    fill: "#2266d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1700",
    "data-name": "\\uC120 1700",
    d: "M27.776-.268H0V-3H27.776Z",
    transform: "translate(23.222 27.921)",
    fill: "#2266d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1702",
    "data-name": "\\uC120 1702",
    d: "M-.268,19.124H-3V0H-.268Z",
    transform: "translate(18.447 32.329)",
    fill: "#2266d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1703",
    "data-name": "\\uC120 1703",
    d: "M-.268,20.49H-3V0H-.268Z",
    transform: "translate(18.447 0)",
    fill: "#2266d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1701",
    "data-name": "\\uC120 1701",
    d: "M10.928-.268H0V-3H10.928Z",
    transform: "translate(0 27.921)",
    fill: "#2266d3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139401",
    "data-name": "\\uD328\\uC2A4 139401",
    d: "M7.992,20.337V9.95h3.246a8.453,8.453,0,0,1,3.439.565,4.36,4.36,0,0,1,1.947,1.737,5.488,5.488,0,0,1,.713,2.9,5.383,5.383,0,0,1-.741,2.809,4.4,4.4,0,0,1-1.982,1.809,8.208,8.208,0,0,1-3.35.565Zm2.274-8.753V18.7h1.117q3.577,0,3.577-3.57,0-3.55-3.577-3.55ZM32.525,9.95,29.6,20.337H27.487L25.33,12.624l-2.1,7.713H21.111L18.162,9.95h2.371l1.771,7.1,1.951-7.1h2.268l1.9,7.12,1.82-7.12ZM42.9,19.7a10.409,10.409,0,0,1-3.949.862,5.5,5.5,0,0,1-4.029-1.427,5.352,5.352,0,0,1-1.451-4A5.247,5.247,0,0,1,34.958,11.2,5.538,5.538,0,0,1,39.007,9.75a8.972,8.972,0,0,1,3.867.917v2.109h-.241a7.416,7.416,0,0,0-1.992-1.154,4.92,4.92,0,0,0-1.489-.245,3.062,3.062,0,0,0-2.4.989,3.94,3.94,0,0,0-.886,2.726,4.1,4.1,0,0,0,.913,2.878,3.429,3.429,0,0,0,2.65.989,4.354,4.354,0,0,0,1.248-.172V16.422H38.353V14.768H42.9Z",
    transform: "translate(1231.469 8754.418)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaDwgIcon);
export default __webpack_public_path__ + "static/media/minerva_dwg_icon.c3408d960e185bff41b527655827ac6e.svg";
export { ForwardRef as ReactComponent };